// "Assinar como PI" (Parte 5.7 `pi-sign`; REQ-AUTHZ-008; `delegation.sign`, step-up): abre a confirmação com o significado "Delego as tarefas listadas" e o hash do
// rascunho; ao concluir a delegação segue a `PendingAcceptance` e o delegado a aceita em "Minhas delegações". Só o PI registrado assina (422 do servidor para os demais).
import { Button } from '@giyus/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { type Delegation, type StudyRef, usePiSignDelegation } from '../../api/delegations';
import { SignatureConfirmDialog } from './SignatureConfirmDialog';

export interface SignDelegationButtonProps {
  readonly study: StudyRef;
  readonly delegation: Delegation;
  readonly taskNames?: ReadonlyMap<string, string> | undefined;
  readonly onDone?: ((message: string) => void) | undefined;
}

export function SignDelegationButton({
  study,
  delegation,
  taskNames,
  onDone,
}: SignDelegationButtonProps) {
  const { t } = useTranslation('authz');
  const [open, setOpen] = useState(false);
  const sign = usePiSignDelegation(study);
  return (
    <>
      <Button
        type="button"
        size="sm"
        data-testid={`delegation-sign-${delegation.id}`}
        onClick={() => {
          sign.reset();
          setOpen(true);
        }}
      >
        {t('delegations.actions.sign')}
      </Button>
      <SignatureConfirmDialog
        open={open}
        onOpenChange={setOpen}
        delegation={delegation}
        mode="pi-sign"
        pending={sign.isPending}
        error={sign.error}
        taskNames={taskNames}
        onConfirm={async (input) => {
          await sign.mutateAsync({ delegationId: delegation.id, input });
          setOpen(false);
          onDone?.(t('delegations.sign.signed'));
        }}
      />
    </>
  );
}
